var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.block.hidden && _vm.breakBlockData)?_c('div',_vm._l((_vm.breakBlockData.content),function(block,index){return _c('break-block-boxes-section',{key:index,attrs:{"block":block}})}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }